export const prependHttpToUrl = (
  url: string | undefined,
): string | undefined => {
  if (url !== undefined && url.substring(0, 4).toLowerCase() !== "http") {
    return `http://${url}`;
  }
  return url;
};
